import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import EkatteEdit from '../controls/EkatteEdit';
import Tools from '../tools/tools';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/customDatePickerWidth.css";
import moment from 'moment'
import IPGrid from '../controls/grid/IPGrid';
import RequestHeader from '../controls/grid/RequestHeader';
import RequestRow from '../controls/grid/RequestRow';


const RequestSearch = (props) => {
    const pageSize = 20;
    let [ss, setss] = useState("");
    let [objectNumber, setObjectNumber] = useState("");

    let [ekatteId, setEkatteId] = useState("0");
    let [address, setAddress] = useState("");
    let [cadastreData, setCadastreData] = useState("");
    let [rowCount, setRowCount] = useState(pageSize);
    let [rows, setRows] = useState(null);
    
    let [users, setUsers] = useState([]);
    let [givenTo, setGivenTo] = useState(0);
    let [requestState, setRequestState] = useState(0);
    let [requestStates, setRequestStates] = useState([]);
    let [fromDate, setFromDate] = useState();
    let [toDate, setToDate] = useState();



    useEffect(() => {
        Comm.Instance().get(`user`).then(result => {
            setUsers(result.data);

        }).catch(error => Tools.ProcessError(error));

        Comm.Instance().get(`requeststatenomen`).then(result => {
            setRequestStates(result.data);

        }).catch(error => Tools.ProcessError(error));
    }, [])



    const Search = () => {
        setRows([]);
        setRowCount(pageSize);
        var data = {
            SS: ss,
            ObjectNumber: objectNumber,
            EkatteId: ekatteId,
            Address: address,
            CadastreData: cadastreData,
            GivenTo: givenTo == "0" ? null : givenTo,
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
            requestStateId: parseInt(requestState)
        };
        Comm.Instance().post(`requestsearch`, data).then(result => {
            setRows(result.data);

        }).catch(error => Tools.ProcessError(error))
    };








    return (

        <div className="container">
            <h2 className="appeal-title mb-5">Търсене</h2>
            <div className="form-row">
                <div className="form-group col-md-3">
                    <label>Данни</label>
                    <input type="text" value={ss} onChange={(e) => setss(e.target.value)} className="form-control" />
                </div>
                <div className="form-group col-md-3">
                    <label>Идентификатор на обект</label>
                    <input type="text" value={objectNumber} onChange={(e) => setObjectNumber(e.target.value)} className="form-control" />
                </div>
                <div className="form-group col-md-3">
                    <label>Адрес</label>
                    <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} className="form-control" />
                </div>
                <div className="form-group col-md-3">
                    <label>Кадастър</label>
                    <input type="text" value={cadastreData} onChange={(e) => setCadastreData(e.target.value)} className="form-control" />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-3">
                    <label>Разпределено на</label>
                    <select value={givenTo} onChange={(e) => setGivenTo(e.target.value)} className="form-control" >
                        <option value="0" key="0"></option>
                        {
                            users.map(item => <option value={item.username} key={item.username}>{item.fullname}</option>)
                        }
                    </select>
                </div>
                <div className="form-group col-md-3">
                    <label>Статус</label>
                    <select value={requestState} onChange={(e) => setRequestState(e.target.value)} className="form-control" >
                        <option value="0" key="0"></option>
                        {
                            requestStates.map(item => <option value={item.requestStateId} key={item.requestStateId}>{item.title}</option>)
                        }
                    </select>
                </div>
                <div className="form-group col-md-3">
                    <label>От дата</label>
                    <DatePicker selected={fromDate} onChange={date => setFromDate(date)} className="form-control" dateFormat="dd.MM.yyyy" />
                </div>
                <div className="form-group col-md-3">
                    <label>До дата</label>
                    <DatePicker selected={toDate} onChange={date => setToDate(date)} className="form-control" dateFormat="dd.MM.yyyy" />
                </div>
            </div>
            <EkatteEdit ekatteId={ekatteId} setValue={setEkatteId} readonly={false} />
            <div className="form-row">
                <div className="form-group col-md-4">
                    <button className="btn btn-primary" onClick={() => Search()}>Търсене</button>
                </div>
            </div>
            {
                rows &&
                <IPGrid rows={rows}
                    header={() => <RequestHeader></RequestHeader>}
                    row={(item) => <RequestRow item={item} ></RequestRow>}>

                </IPGrid>

            }


        </div>

    );
}


export default RequestSearch;